export var ContentType = /*#__PURE__*/ function(ContentType) {
    ContentType["VIDEO"] = "video";
    ContentType["AUDIO"] = "audio";
    ContentType["TEXT"] = "text";
    ContentType["IMAGE"] = "image";
    return ContentType;
}({});

//# sourceMappingURL=psf.enums.js.map